
import PageHeader from "../../Components/PageHeader/PageHeader";
import UserMainTable from "../../Components/UserMainTable/UserMainTable";


const UsersCrud = () => {

    return (
        <>

            {/* HEADER */}
            <PageHeader />

            <UserMainTable />

        </>
    );

}

export default UsersCrud;
